import * as React from "react";
import { SVGProps } from "react";
export const CarIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <mask
            id="mask0_11068_94235"
            style={{
                maskType: "alpha",
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={20}
            height={20}
        >
            <rect width={20} height={20} fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_11068_94235)">
            <path
                d="M5 15.8334V16.6667C5 16.9029 4.92014 17.1008 4.76042 17.2605C4.60069 17.4202 4.40278 17.5001 4.16667 17.5001H3.33333C3.09722 17.5001 2.89931 17.4202 2.73958 17.2605C2.57986 17.1008 2.5 16.9029 2.5 16.6667V10.0001L4.25 5.00008C4.33333 4.75008 4.48264 4.54869 4.69792 4.39591C4.91319 4.24314 5.15278 4.16675 5.41667 4.16675H14.5833C14.8472 4.16675 15.0868 4.24314 15.3021 4.39591C15.5174 4.54869 15.6667 4.75008 15.75 5.00008L17.5 10.0001V16.6667C17.5 16.9029 17.4201 17.1008 17.2604 17.2605C17.1007 17.4202 16.9028 17.5001 16.6667 17.5001H15.8333C15.5972 17.5001 15.3993 17.4202 15.2396 17.2605C15.0799 17.1008 15 16.9029 15 16.6667V15.8334H5ZM4.83333 8.33341H15.1667L14.2917 5.83341H5.70833L4.83333 8.33341ZM6.25 13.3334C6.59722 13.3334 6.89236 13.2119 7.13542 12.9688C7.37847 12.7258 7.5 12.4306 7.5 12.0834C7.5 11.7362 7.37847 11.4411 7.13542 11.198C6.89236 10.9549 6.59722 10.8334 6.25 10.8334C5.90278 10.8334 5.60764 10.9549 5.36458 11.198C5.12153 11.4411 5 11.7362 5 12.0834C5 12.4306 5.12153 12.7258 5.36458 12.9688C5.60764 13.2119 5.90278 13.3334 6.25 13.3334ZM13.75 13.3334C14.0972 13.3334 14.3924 13.2119 14.6354 12.9688C14.8785 12.7258 15 12.4306 15 12.0834C15 11.7362 14.8785 11.4411 14.6354 11.198C14.3924 10.9549 14.0972 10.8334 13.75 10.8334C13.4028 10.8334 13.1076 10.9549 12.8646 11.198C12.6215 11.4411 12.5 11.7362 12.5 12.0834C12.5 12.4306 12.6215 12.7258 12.8646 12.9688C13.1076 13.2119 13.4028 13.3334 13.75 13.3334Z"
                fill="currentColor"
            />
        </g>
    </svg>
);
CarIcon.displayName = "CarIcon";
